export default __webpack_public_path__ + "static/media/inovacao.67b8bc6a.png";